import React from "react"
import autobind from "class-autobind"
import FinddWideDrawer from "../../common/FinddWideDrawer"
import { RaisedButton, CircularProgress } from "material-ui"
import strings from "../../../localization/strings"
import DateTimeRangeSelect from "../../common/DateTimeRangeSelect"
import GlobalPunchEmployeesInfoHoverIcon from "./GlobalPunchEmployeesInfoHoverIcon"
import moment from "moment"
import { IPunchBundle, IUIUser, IDate } from "../../../models"
import * as api from "../../../api/api"
import GlobalPunchTable from "./GlobalPunchTable"
import GlobalPunchEditDialog from "./GlobalPunchEditDialog"
interface IProps {
    open: boolean
    dayStartTime24Hour: number
    startDate: IDate
    endDate: IDate
    globalPunchEmployees: IUIUser[]
    handleClose(): void
    handleEditGlobalPunches(punchBundles: IPunchBundle[]): void
}
interface IState {
    // start/end date time is browser local time
    startDateTime: IDate
    endDateTime: IDate
    isValidDateRange: boolean,
    dateRangeChanged: boolean,
    loadingPunchData: boolean
    punchBundles: IPunchBundle[],
    selectedPunchBundles: IPunchBundle[]
    openGlobalPunchEditDialog: boolean
}

export default class GlobalPunchEditDrawer extends React.Component<IProps, IState>  {
    constructor(props: IProps) {
        super(props)
        this.state = {
            startDateTime: props.startDate,
            endDateTime: props.endDate,
            isValidDateRange: true,
            dateRangeChanged: true,
            loadingPunchData: false,
            punchBundles: [],
            selectedPunchBundles: [],
            openGlobalPunchEditDialog: false
        }
        autobind(this)
    }

    componentDidMount() {
        this.getPunches()
    }

    componentWillReceiveProps(nextProps: IProps) {
        if (this.props.open !== nextProps.open) {
            this.setState({
                startDateTime: nextProps.startDate,
                endDateTime: nextProps.endDate,
                isValidDateRange: true,
                dateRangeChanged: true,
                loadingPunchData: false,
                punchBundles: [],
                selectedPunchBundles: []
            }, () =>
                this.getPunches()
            )
        }
    }

    getPunches() {
        this.props.open &&
            this.setState({ loadingPunchData: true, dateRangeChanged: false }, async () => {
                const res = await api.getGlobalPunches(this.props.globalPunchEmployees.map(i => i.Id), moment(this.state.startDateTime).utc(true).format(), moment(this.state.endDateTime).utc(true).format())
                this.setState({
                    loadingPunchData: false,
                    punchBundles: res.data,
                    selectedPunchBundles: res.data
                })
            })
    }

    render() {
        return (
            <FinddWideDrawer
                open={this.props.open}
                title={strings.Global_Punch_Edit}
                handleClose={this.props.handleClose}
            >
                <div style={{ fontWeight: 600, fontSize: 25 }}>{strings.Filter_Punches}</div>
                <div style={{ fontSize: 15, marginTop: 15, lineHeight: "17px" }}>{strings.Global_Punch_Edit_Drawer_Alert}</div>
                <GlobalPunchEmployeesInfoHoverIcon
                    style={{ marginTop: 20 }}
                    globalPunchEmployees={this.props.globalPunchEmployees}
                />

                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                        <DateTimeRangeSelect
                            dayStartTime24Hour={this.props.dayStartTime24Hour}
                            startDateTime={this.state.startDateTime}
                            endDateTime={this.state.endDateTime}
                            handleChange={(startDateTime, endDateTime, isValidDateRange, todayClicked) =>
                                todayClicked ?
                                    this.setState({ startDateTime, endDateTime, isValidDateRange }, () => this.getPunches()) :
                                    this.setState({ startDateTime, endDateTime, isValidDateRange, dateRangeChanged: true })
                            }
                        />
                        <RaisedButton
                            data-intercom-target={"Timecards-GlobalEdit-Btn-ApplyFilter"}
                            style={{ marginRight: 80, marginBottom: -10 }}
                            secondary
                            label={strings.Apply_Filter}
                            disabled={!this.state.isValidDateRange || !this.state.dateRangeChanged || this.state.loadingPunchData}
                            onClick={this.getPunches}
                        />
                    </div>
                    {!this.state.dateRangeChanged && !this.state.loadingPunchData && this.state.selectedPunchBundles.length > 0 &&
                        <RaisedButton
                            data-intercom-target={"Timecards-GlobalEdit-Btn-EditSelectedPunches"}
                            secondary
                            style={{ marginBottom: -10 }}
                            disabled={this.state.selectedPunchBundles.length === 0}
                            label={strings.Edit_Selected_Punches}
                            onClick={() => this.setState({ openGlobalPunchEditDialog: true })}
                        />
                    }
                </div>
                {!this.state.dateRangeChanged &&
                    <div>
                        {this.state.loadingPunchData ?
                            <div className="spinner"><CircularProgress /></div> :
                            this.state.punchBundles.length === 0 ?
                                <h2 style={{ textAlign: "center", marginTop: 50 }}>
                                    {strings.No_punch_found}
                                </h2> :
                                <GlobalPunchTable
                                    globalPunchEmployees={this.props.globalPunchEmployees}
                                    punchBundles={this.state.punchBundles}
                                    selectedPunchBundles={this.state.selectedPunchBundles}
                                    handleSelect={selectedPunchBundles => this.setState({ selectedPunchBundles })}
                                />
                        }
                    </div>
                }
                {this.state.openGlobalPunchEditDialog &&
                    <GlobalPunchEditDialog
                        globalPunchEmployees={this.props.globalPunchEmployees}
                        selectedPunchBundles={this.state.selectedPunchBundles}
                        handleClose={() => this.setState({ openGlobalPunchEditDialog: false })}
                        handleEditGlobalPunches={punchBundles =>
                            this.setState({ openGlobalPunchEditDialog: false }, () =>
                                this.props.handleEditGlobalPunches(punchBundles)
                            )
                        }
                    />
                }
            </FinddWideDrawer>
        )
    }
}
